/** Pure helper — exported for testing. */
export function getCollapsedCrumbs(trail: Array<{ id: string; name: string }>) {
  const MAX_VISIBLE = 1;
  const showEllipsis = trail.length > MAX_VISIBLE;
  return {
    showEllipsis,
    visibleItems: showEllipsis ? trail.slice(-MAX_VISIBLE) : trail,
    hiddenItems: showEllipsis ? trail.slice(0, -MAX_VISIBLE) : [],
  };
}
